'use strict';
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');

module.exports = withRenderedMain(
    withCachedSelectors(
        BaseView.extend({
            selectors: {
                primeMerchandisingBubbleText: '.prime_merchandising_bubble_text',
            },

            initialize() {
                this.replaceTextWithCode();
            },

            replaceTextWithCode() {
                const insideText = `<span class="odf-text-secondary">` + this.keys.bagsSeats + `</span>`;
                const fullText = Odigeo.Utils.replaceCmsKeyArgs(this.keys.primeMerchandisingBubbleAcquisition, insideText);
                this.$el.find(this.selectors.primeMerchandisingBubbleText).append(fullText);
            },
        })
    )
);

